import React, {Fragment} from 'react';

import {DebouncedInput} from 'app/general/primitives/DebouncedInput';
import {gt} from 'app/utils/i18n';

import type {StepEditFieldProps} from '../commonprops';

export const StepEditDateField = ({
  label,
  onChange,
  optionsButton,
}: StepEditFieldProps) => (
  <Fragment>
    <div className="input-group">
      <DebouncedInput
        className="form-control"
        type="text"
        value={label}
        onChange={onChange}
        placeholder={gt('Date label...')}
      />
      {optionsButton}
    </div>
    <div className="input-group">
      <input
        className="form-control ext-black-50"
        disabled
        type="text"
        value={gt('Date will be entered here.')}
      />
    </div>
  </Fragment>
);
